<template>
	<Mango @update:data="setProduct" :main="true" :suspend="true" class="pb-20">
		<div class="flex w-full justify-center">
			<div class="w-full">
				<div class="flex w-full justify-center px-6">
					<div class="flex flex-col md2:flex-row w-full max-w-8xl justify-between gap-y-15 md2:gap-x-2">
						<VerticalImageScroller
							v-if="product?.images"
							:images="product.images"
							class="shrink-0 order-3 md2:order-1 w-full md2:w-32 print:hidden mt-4 md2:mt-0"
							@update:image="updateImage"
						/>

						<div class="order-2 md2:order-2 w-full md2:max-w-[40%] lg:max-w-[45%] xl:max-w-[50%] justify-center flex md2:block md2:mx-6">
							<div
								class="relative flex w-full justify-center max-w-3xl 2xl:ml-4 bg-ihh-light-lavendar rounded-xl items-center p-10 shadow h-full overflow-hidden min-h-[450px] max-h-[450px] md:min-h-[600px] md:max-h-[600px]"
								@mousemove="updateZoom"
								@mouseleave="resetZoom"
							>
								<img
									id="zoomImage"
									ref="zoomImage"
									class="rounded max-w-full max-h-full object-center object-contain transition-transform duration-300 scale-100 hover:scale-[3] cursor-zoom-in mix-blend-darken"
									:src="selectedImage"
									alt="selected image"
									:style="zoomStyle"
								/>
							</div>
							<div v-show="this.product?.id" class="w-full justify-start mt-4 hidden md2:flex">
								<ProductSharingOptions :product="product" />
							</div>
						</div>

						<!-- <div class="order-1 md2:order-3 flex w-full justify-center md2:w-fit">
							<div class="space-y-6 py-4 order-1 md2:order-none block md2:hidden w-full max-w-3xl">
								<div class="flex w-full justify-between text-start text-ihh-midnight-gray text-xl md2:text-4xl font-semibold tracking-wide">
									<span class="pr-20">{{ product.name }}</span>
									<div class="cursor-pointer relative z-10 flex">
										<div class="w-10 h-8">
											<button @click="addListItem" class="bg-gradient-to-b from-ihh-pink to-ihh-purple p-1.5 rounded-md absolute shadow">
												<img src="/images/ob-heart-0129.svg" class="w-6 h-6" />
                                            </button>
										</div>
									</div>
								</div>
							</div>
						</div> -->

						<div class="order-1 md2:order-3 flex w-full justify-center md2:w-fit md2:justify-around">
							<div class="space-y-6 py-4 w-full md2:w-fit max-w-3xl md2:max-w-none">
								<div class="flex w-full text-start text-ihh-midnight-gray text-3xl font-semibold tracking-wide flex justify-between">
									<span class="pr-5">{{ product?.name }}</span>
									<div class="cursor-pointer relative z-10 flex">
										<div class="w-10 h-8">
											<button @click="addListItem" class="bg-gradient-to-b from-ihh-pink to-ihh-purple p-1.5 rounded-md absolute shadow">
												<img src="/images/ob-heart-0129.svg" class="w-6 h-6" />
											</button>
										</div>
									</div>
								</div>

								<div>
									<div class="flex w-full sm:pb-0 text-sm md2:text-lg flex-col md2:flex-row flex">
										<div class="text-ihh-midnight-gray font-normal text-base sm:text-2xl tracking-wide text-start flex flex-col justify-start w-full">
											<div class="flex w-full justify-start" :class="{ 'flex-col gap-4': isPriceHidden }">
												<div class="flex-col w-full" :class="{ 'md2:max-w-xl': isPriceHidden }">
													<div
														v-if="isPriceHidden"
														class="rounded-xl border border-ihh-dark-salmon/25 bg-gradient-to-br from-ihh-pink/20 via-ihh-light-lavendar/50 to-ihh-white p-4 md:p-5 shadow-sm space-y-3"
													>
														<div class="flex flex-wrap items-center gap-2">
															<span class="bg-ihh-dark-salmon text-ihh-white text-sm font-semibold tracking-wide px-3 py-1.5 rounded-md">
																Call for Pricing
															</span>
														</div>
														<p class="text-sm text-ihh-slate-gray leading-relaxed">Contact us for pricing or to place an order.</p>
														<div class="pt-1 border-t border-ihh-dark-salmon/15">
															<p class="text-sm font-semibold text-ihh-midnight-gray">Message from In His Hands:</p>
															<div class="mt-1.5 space-y-1">
																<a
																	v-if="callForPricingPhoneHref"
																	:href="callForPricingPhoneHref"
																	class="block text-lg md:text-xl font-semibold text-ihh-dark-salmon hover:text-ihh-salmon underline underline-offset-2"
																>
																	{{ priceDisplayLabel }}
																</a>
																<p v-else class="text-lg md:text-xl font-semibold text-ihh-midnight-gray">
																	{{ priceDisplayLabel }}
																</p>
																<p class="text-sm md:text-base text-ihh-midnight-gray">
																	or email us at
																	<a
																		:href="callForPricingEmailHref"
																		class="font-semibold text-ihh-dark-salmon hover:text-ihh-salmon underline underline-offset-2"
																	>
																		help@inhishands.com
																	</a>
																</p>
															</div>
														</div>
														<router-link
															to="/help-center"
															class="inline-flex text-sm font-semibold text-ihh-dark-salmon hover:text-ihh-salmon underline underline-offset-2"
														>
															Visit Help Center
														</router-link>
													</div>
													<template v-else>
														<template v-if="variant?.wasPrice && variant?.wasPrice > variant?.currentPrice">
															<div class="text-xl text-red-500 font-semibold">Sale!</div>
															<div
																class=""
																:class="
																	variant?.wasPrice || product?.outOfStock
																		? 'line-through text-ihh-slate-gray/80 text-lg'
																		: 'text-ihh-midnight-gray font-normal text-base'
																"
															>
																{{ variant?.wasPrice?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}
															</div>
														</template>
														<div class="md:text-xl text-2xl">
															<span :class="{ 'line-through': BlackFridaySaleIsActive }">{{
																currentPrice?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
															}}</span>
															<span v-if="BlackFridaySaleIsActive" class="ml-2 font-bold text-[#F44631]">{{
																salePrice?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
															}}</span>
														</div>
														<div v-if="BlackFridaySaleIsActive">
															<span v-if="BlackFridaySaleIsActive" class="ml-2 font-bold text-[#F44631] text-[20px]"
																>Black Friday Sale with code: BF25</span
															>
														</div>
													</template>
												</div>
												<div class="flex justify-end m-auto">
													<div class="flex flex-col lg:flex-row">
														<div class="flex w-full justify-end text-xs text-ihh-slate-gray mx-2 font-semibold m-auto whitespace-nowrap">
															<span class="flex items-center cursor-pointer hover:opacity-80 hover:underline" @click="scrollToReviews"
																><Stars :stars="product?.rating" class="w-20" /> <span class="ml-1">({{ product?.reviewsCount }})</span></span
															>
														</div>
														<div class="flex w-full justify-end text-xs text-ihh-slate-gray font-semibold m-auto whitespace-nowrap">
															<button @click="showReview = true" class="underline text-ihh-slate-gray hover:text-ihh-dark-salmon">
																Write a Review
															</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="hidden md2:block">
									<div v-if="product?.upc" class="text-sm text-ihh-slate-gray">
										<span class="text-ihh-midnight-gray font-semibold mr-1">UPC:</span>
										{{ product?.upc }}
									</div>
									<div v-if="bulkPricingAvailable && !isPriceHidden" class="flex justify-start items-center my-3 space-x-2">
										<span class="bg-ihh-check rounded py-1 px-2 text-ihh-midnight-gray font-ihh-bold">Bulk Pricing Available</span>
										<span
											@click="showBulkPricingRules = true"
											class="text-xs sm:text-sm font-semibold underline text-ihh-dark-salmon hover:text-ihh-salmon hover:cursor-pointer"
											>Buy in bulk and save</span
										>
									</div>
									<div v-if="product?.availabilityDescription" class="text-sm text-ihh-slate-gray">
										<span class="text-ihh-midnight-gray font-semibold mr-1">Availability:</span>
										<span>{{ product?.availabilityDescription }}</span>
									</div>

									<div v-if="product?.orderQuantityMaximum" class="text-sm text-ihh-slate-gray">
										<span class="text-ihh-midnight-gray font-semibold mr-1">Maximum Purchase:</span>
										{{ product?.orderQuantityMaximum }} unit
									</div>
									<div v-for="f in product?.customFields" :key="f.bcId" class="text-sm text-ihh-slate-gray">
										<span class="text-ihh-midnight-gray font-semibold mr-1">{{ f.name }}:</span>
										{{ f.value }} unit
									</div>
								</div>

								<AddToCartThings
									v-if="canPurchaseOnline"
									ref="desktopAddToCart"
									class="hidden md2:block"
									:product="product"
									:variant="variant"
									:active="isDesktopAddToCartVisible"
									:increment="purchaseIncrement"
									:selectedOptions="selectedOptions"
									:qty="quantity"
									:cartQty="cartQty"
									:isAddToBagDisabled="isAddToBagDisabled"
									:stockAvailable="stockAvailable"
									:currentStock="currentStock"
									@update:qty="quantity = $event"
									@addToBag="addToBag"
									@showNotify="showNotifyModal"
									@selectOption="selectOption"
									@contractSelected="addContract"
									@contractRemoved="removeContract"
								/>
							</div>
						</div>

						<AddToCartThings
							v-if="canPurchaseOnline"
							ref="mobileAddToCart"
							class="md2:hidden order-4 md2:order-none"
							:product="product"
							:variant="variant"
							:active="isMobileAddToCartVisible"
							:increment="purchaseIncrement"
							:selectedOptions="selectedOptions"
							:qty="quantity"
							:cartQty="cartQty"
							:isAddToBagDisabled="isAddToBagDisabled"
							:stockAvailable="stockAvailable"
							:currentStock="currentStock"
							@update:qty="quantity = $event"
							@addToBag="addToBag"
							@showNotify="showNotifyModal"
							@selectOption="selectOption"
							@contractSelected="addContract"
							@contractRemoved="removeContract"
							v-model="textValues"
						/>

						<div v-show="product?.id" class="md2:hidden order-5 w-full mt-4 pt-4 border-t border-gray-200">
							<ProductSharingOptions :product="product" />
						</div>
					</div>
				</div>
				<div class="flex w-full justify-center px-3 mt-12" id="details">
					<div class="flex w-full max-w-3xl md2:max-w-8xl gap-x-4">
						<!-- Description Button -->
						<button
							@click="activeSection = 'description'"
							:class="[
								'text-center flex w-full justify-center py-3.5 px-2 border border-slate-100 rounded-lg text-description font-semibold shadow-md tracking-wide',
								activeSection === 'description' ? 'bg-ihh-midnight-gray text-white' : 'bg-gradient-to-b from-ihh-pink to-ihh-purple text-ihh-midnight-gray',
							]"
						>
							Description
						</button>
						<button
							@click="activeSection = 'shipping'"
							:class="[
								'text-center flex w-full justify-center py-3.5 px-2 border border-slate-100 rounded-lg text-description font-semibold shadow-md tracking-wide',
								activeSection === 'shipping' ? 'bg-ihh-midnight-gray text-white' : 'bg-gradient-to-b from-ihh-pink to-ihh-purple text-ihh-midnight-gray',
							]"
						>
							Shipping &amp; Returns
						</button>
						<button
							v-if="product?.videos?.length"
							@click="activeSection = 'videos'"
							:class="[
								'text-center flex w-full justify-center py-3.5 px-2 border border-slate-100 rounded-lg text-description font-semibold shadow-md tracking-wide',
								activeSection === 'videos' ? 'bg-ihh-midnight-gray text-white' : 'bg-gradient-to-b from-ihh-pink to-ihh-purple text-ihh-midnight-gray',
							]"
						>
							Videos
						</button>
					</div>
				</div>

				<div class="flex w-full justify-center">
					<div class="w-full md2:max-w-8xl">
						<div v-if="activeSection === 'shipping'">
							<div class="w-full max-w-8xl space-y-5 p-6">
								<div class="w-full text-start text-ihh-midnight-gray text-2xl font-semibold tracking-wide">Shipping and Returns</div>
								<div class="text-start text-ihh-gray-600 font-normal text-sm md2:text-description leading-6">
									Shipping cost is based on weight. Just add products to your cart and use the Shipping Calculator to view the different options. We offer
									free shipping on orders over $125 shipping to the lower 48 states. We want you to be 100% satisfied with your purchase. Most items in new
									condition can be returned or exchanged within 90 days of purchase. Read more about our shipping options
									<router-link to="/shipping-info" class="text-ihh-dark-salmon underline">here</router-link> and returns
									<router-link to="/returns" class="text-ihh-dark-salmon underline">here</router-link>.
								</div>
							</div>
						</div>

						<div v-if="activeSection === 'description'" class="w-full max-w-8xl p-6">
							<!-- this is the description tag -->
							<!-- <Description /> -->
							<div v-safe-html="sanitizeProductDescription(product?.description)" class="space-y-4 prose !max-w-full prose description" />
						</div>

						<div v-if="activeSection === 'videos'" class="w-full max-w-8xl p-6">
							<!-- this is the description tag -->
							<!-- <Description /> -->
							<div class="w-full grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-8">
								<div v-for="video in product?.videos" :key="video.videoId" class="w-full">
									<iframe
										:src="`https://www.youtube.com/embed/${video.videoId}`"
										frameborder="0"
										allowfullscreen
										class="aspect-video rounded-lg w-full"
									></iframe>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="flex w-full justify-center">
					<div class="mt-12 w-full max-w-8xl px-3">
						<ImageScroller class="m-auto print:m-0" label="Image Gallery">
							<div
								v-for="{ url: image } in product?.images"
								:key="image"
								class="snap-start w-[calc((100%-1rem)/2)] sm:w-[calc((100%-2rem)/3)] md:w-[calc((100%-3rem)/4)] shrink-0"
							>
								<div
									class="relative group flex w-full justify-center bg-ihh-light-lavendar rounded-xl h-full min-h-52 md2:min-h-77 max-h-77 items-center p-4 sm:p-8 md2:p-12 overflow-hidden shadow"
								>
									<img class="w-full object-center object-contain aspect-square mix-blend-darken" :src="image" :alt="product?.name" />
									<div
										class="absolute inset-0 flex items-end justify-center opacity-0 bg-ihh-white/40 transition transform duration-300 ease-in-out group-hover:opacity-100"
									></div>
								</div>
							</div>
						</ImageScroller>
					</div>
				</div>

				<div id="reviews-section">
					<Reviews :product="product" :openReview="showReview" @closeReview="showReview = false" />
				</div>
				<RelatedProducts class="print:hidden" :product="product" />
			</div>
		</div>

		<Modal v-if="showNotify" @hide="showNotify = !showNotify" max-width="max-w-lg">
			<div class="flex flex-col space-y-6">
				<div>Get notified when this product is back in stock.</div>

				<div class="flex flex-col space-y-1">
					<label class="text-ihh-midnight-gray">Email</label>
					<input
						type="email"
						placeholder="Email Address"
						v-model="notifyEmail"
						class="border py-1.5 pl-2 placeholder-ihh-form-label text-ihh-midnight-gray rounded-sm w-full border-ihh-form-label"
					/>
				</div>

				<button
					v-if="!notifyMessage?.length"
					@click="notifyWhenAvailable"
					class="w-full rounded bg-ihh-dark-salmon font-bold text-ihh-white text-center tracking-wide py-2 active:scale-90"
				>
					Notify me when available
				</button>
				<div v-else class="w-full">
					<div class="text-green-700 bg-green-200 w-full py-2 flex justify-between px-4 items-center">
						<div class="w-full text-center">
							<div>
								{{ notifyMessage }}
							</div>
						</div>
						<button @click="showNotify = false" class="w-1/4 font-bold text-green-700 text-center tracking-wide py-2 active:scale-90">Close</button>
					</div>
				</div>
			</div>
		</Modal>

		<WishlistModal :show="showWishlistOptions" @update:show="showWishlistOptions = $event" :product="product" />

		<Modal v-if="showBulkPricingRules" @hide="showBulkPricingRules = !showBulkPricingRules" max-width="max-w-xl">
			<h2 class="text-ihh-midnight-gray border-b border-ihh-form-label py-6 pb-8 flex justify-center text-3xl tracking-wide font-semibold">Bulk discount rates</h2>
			<div class="w-full flex justify-center">
				<div class="text-ihh-gray-address w-4/5">
					<div class="mb-4">Below are the available bulk discount rates for each individual item when you purchase a certain amount</div>
					<div>
						<ul>
							<li v-for="rule in product?.bulkPricingRules" class="list-disc ml-3">
								<div v-if="rule.type === 'percent'">
									<span v-if="rule.quantityMax">Buy {{ rule.quantityMin }} - {{ rule.quantityMax }} and get {{ rule.amount }}% off</span>
									<span v-else>Buy {{ rule.quantityMin }} or above and get {{ rule.amount }}% off</span>
								</div>
								<div v-if="rule.type === 'price'">
									<span v-if="rule.quantityMax">Buy {{ rule.quantityMin }} - {{ rule.quantityMax }} and get ${{ rule.amount.toFixed(2) }} off</span>
									<span v-else>Buy {{ rule.quantityMin }} or above and get ${{ rule.amount.toFixed(2) }} off</span>
								</div>
								<div v-if="rule.type === 'fixed'">
									<span v-if="rule.quantityMax">Buy {{ rule.quantityMin }} - {{ rule.quantityMax }} and pay only ${{ rule.amount.toFixed(2) }} each</span>
									<span v-else>Buy {{ rule.quantityMin }} or above and pay only ${{ rule.amount.toFixed(2) }} each</span>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</Modal>
	</Mango>
</template>

<script>
import Description from './ihh-items/description.vue'
import Stars from '../partials/stars.vue'
import AboutService from './ihh-items/about-service.vue'
import AddedFilters from './ihh-items/added-filters.vue'
import RelatedProducts from './ihh-items/related-products.vue'
import ImageGallery from './ihh-items/image-gallery.vue'
import ImageScroller from './ihh-items/image-scroller.vue'
import Reviews from './ihh-items/reviews.vue'
import ProductOptionButtons from '../partials/product-option-buttons.vue'
import RecentlyViewed from '../account/recently-viewed.vue'
import Mango from '../../helpers/mango'
import aa from 'search-insights'
import Swal from 'sweetalert2'
import VerticalImageScroller from './ihh-items/vertical-image-scroller.vue'
import axios from 'axios'
import AddToCartThings from '../layout/add-to-cart-things.vue'
import ProductSharingOptions from '../partials/product-sharing-options.vue'
import WishlistModal from '../products/wishlist-modal.vue'

export default {
	components: {
		Stars,
		AddedFilters,
		ImageScroller,
		ImageGallery,
		AboutService,
		RelatedProducts,
		Reviews,
		Description,
		ProductOptionButtons,
		VerticalImageScroller,
		AddToCartThings,
		ProductSharingOptions,
		WishlistModal,
	},
	inject: ['store'],
	data() {
		return {
			isMobileAddToCartVisible: undefined,
			isDesktopAddToCartVisible: undefined,
			showNotify: false,
			notifyEmail: '',
			notifyMessage: '',
			showReview: false,
			showSocials: false,
			showWishlistOptions: false,
			showBulkPricingRules: false,
			currentCartItem: null,
			product: null,
			quantity: 1,

			isSendlaneReady: false,
			currentIndex: 0,
			visibleProducts: [],
			selectedSponsorship: null,
			selectedOptions: [],
			selectedImage: '',
			filtersApplied: false,
			activeSection: 'description',
			contract: null,
			zoomStyle: {
				transformOrigin: 'center center',
				objectFit: 'contain',
			},
			queryID: null,
			isSearchResult: null,
			position: null,
			excludedCategories: [
				'66d8b83f6e195ee1d5e05685',
				'66d8b83f6e195ee1d5e05686',
				'66d8b83f6e195ee1d5e05687',
				'66d8b83f6e195ee1d5e05688',
				'66d8b83f6e195ee1d5e056a7',
				'66d8b83f6e195ee1d5e056c9',
				'679bd3f57c8bf4c6acdf1126',
				'66d8b83f6e195ee1d5e05645',
				'66d8b83f6e195ee1d5e05670',
			],
			excludedBrands: ['66d8b8bbedc312a92501da4b', '691d791e695943f5c4f9eb83'],
			excludedProducts: ['67f539096a10d89fef421c95', '672e786e1c74a764bc880168', '671fc2cdb1c53f07c81d9914'],
		}
	},
	mounted() {
		// Set up intersection observers for both AddToCartThings components
		this.store.showBag = false

		// Check for Algolia queryID param
		this.queryID = this.$route.query?.queryID || null
		let searchResult = this.$route.query?.searchResult
		if (searchResult === 'true') {
			this.isSearchResult = true
			this.position = this.$route.query?.position || null
		} else if (searchResult === 'false') {
			this.isSearchResult = false
		} else {
			this.isSearchResult = null
		}

		// this.validateProductOptionInventory()

		const createObserver = (callback) => {
			return new IntersectionObserver(([entry]) => callback(entry.isIntersecting), {
				root: null,
				rootMargin: '0px',
				threshold: 0,
			})
		}

		const mobileObserver = createObserver((isVisible) => {
			this.isMobileAddToCartVisible = isVisible
			if (isVisible) {
				this.isDesktopAddToCartVisible = false
			}
		})

		const desktopObserver = createObserver((isVisible) => {
			this.isDesktopAddToCartVisible = isVisible
			if (isVisible) {
				this.isMobileAddToCartVisible = false
			}
		})

		// Start observing both components
		this.$nextTick(() => {
			//this.fixLinks()

			if (this.$refs.mobileAddToCart?.$el instanceof Element) {
				mobileObserver.observe(this.$refs.mobileAddToCart.$el)
			}
			if (this.$refs.desktopAddToCart?.$el instanceof Element) {
				desktopObserver.observe(this.$refs.desktopAddToCart.$el)
			}
		})

		this.addRecentlyViewed()

		if (process.env.NODE_ENV !== 'production') {
			console.log('Product BC ID: ', this.product?.bcId)
		}

		if (typeof gtag === 'function') {
			const product = {
				item_id: this.product?.sku || '',
				item_name: this.product?.name,
				item_brand: this.product?.brand,
				quantity: this.quantity,
				price: this.product?.currentPrice,
			}
			const viewItemEvent = gtag('event', 'view_item', {
				value: product?.price * product?.quantity,
				currency: 'USD',
				items: [product],
			})
			console.log('GA4 - View item event: ', viewItemEvent)
		}

		// Algolia event tracking
		try {
			if (this.isSearchResult === true) {
				const event = aa('clickedObjectIDsAfterSearch', {
					index: 'InHisHands',
					queryID: this.queryID,
					eventName: 'Product Clicked',
					objectIDs: [this.product.id],
					positions: [Number(this.position) + 1],
				})
				console.log('Algolia product clicked event: ', event)
			} else if (this.isSearchResult === false) {
				const event = aa('clickedObjectIDs', {
					eventName: 'Product Clicked',
					index: 'InHisHands',
					objectIDs: [this.product.id],
				})
				console.log('Algolia product clicked event: ', event)
			}
		} catch (error) {
			console.error('Algolia product clicked event error', error)
		}
	},

	watch: {
		product: {
			handler(newValue) {
				if (newValue?.customUrl?.url) {
					this.productUrl = newValue.customUrl.url
				}
			},
			deep: true,
		},
		// quantity: {
		// 	handler(newValue) {
		// 		if (this.existingItem) {
		// 			console.log('quantity watcher triggering addToBag')
		// 			this.addToBag(false)
		// 		}
		// 	},
		// 	deep: true,
		// },
		variant: {
			handler(newValue) {
				if (newValue?.imageUrl) {
					this.selectedImage = newValue.imageUrl
				}

				// Variant changes will automatically update the computed isAddToBagDisabled property
			},
			deep: true,
			immediate: true,
		},
		// 'product.description': {
		// 	handler() {
		// 		this.$nextTick(() => {
		// 			this.fixLinks()
		// 		})
		// 	},
		// 	immediate: true,
		// },
		quantity: {
			handler(newQuantity) {
				this.handleQtyChange()
			},
		},
		purchaseIncrement: {
			handler(newIncrement, oldIncrement) {
				// When the effective increment changes (e.g. switching to a variant sold in 5s),
				// re-snap the current quantity to a valid multiple.
				if (newIncrement === oldIncrement) return
				this.quantity = this.snapQuantity(this.quantity)
			},
		},
	},

	methods: {
		scrollToReviews() {
			document.getElementById('reviews-section')?.scrollIntoView({ behavior: 'smooth' })
		},
		async addToBag(textValues = [], selectedModifierProducts = [], fileValues = []) {
			if (!this.canPurchaseOnline) return

			if (this.store.editingKit) {
				let existingItem = this.store.editingKit?.products?.find?.((c) => c.product.id === this.product.id)
				if (existingItem) {
					existingItem.quantity += this.quantity
				} else {
					this.store.editingKit?.products?.push?.({
						product: this.product,
						quantity: this.quantity,
						variant: this.variant || null,
						optional: this.store.editingKit && !!this.store.birthKitOptional ? true : undefined,
					})
				}
				return this.$router.push(`/birthKits/${this.store.editingKit?.customUrl?.url || this.store.editingKit?.slug || this.store.editingKit?.id}/edit`)
			}

			if (!this.requiredOptionsSelected.value) {
				Swal.fire({
					text: `Please select ${this.requiredOptionsSelected.options.join(' and ')} options`,
					icon: 'warning',
					confirmButtonText: 'OK',
					confirmButtonColor: '#e59789',
				})
				return
			}

			if (this.product.outOfStock || this.variantsOutOfStock) return

			if (this.productOptions?.length && !this.variant) {
				Swal.fire({ text: 'Please select all required options', icon: 'warning' })
				return
			}

			// check if textValues has length, and if so, check if any of the values have required: true. If true, verify the values have length
			if (textValues?.length) {
				const requiredTextValues = textValues.filter((tv) => tv.required)
				if (requiredTextValues.length) {
					const hasEmptyValues = requiredTextValues.some((tv) => !tv.value?.length)
					const missingValues = requiredTextValues.filter((tv) => !tv.value?.length)
					if (hasEmptyValues) {
						Swal.fire({ text: `Please provide your ${missingValues.map((tv) => tv.name).join(' and ')} to purchase this product.`, icon: 'warning' })
						return
					}
				}
			}

			if (window?.Clyde?.getActiveProduct()?.contracts?.length && !this.contract) {
				try {
					await this.waitForClydeModalToClose()
				} catch (error) {
					console.errr('Error waiting for Clyde modal to close: ', error?.trace || error)
				}
			}

			// let existingItem = this.store.editingKit
			// 	? this.store.editingKit?.products?.find?.((c) => c.product.id === this.product.id)
			// 	: this.store.cart?.cartItems?.find?.((c) => c.item.id === this.product.id)

			this.getExistingItem()
			if (this.currentCartItem) {
				this.currentCartItem.quantity = this.quantity

				// Swal toast style alert that quantity is update
				Swal.fire({
					text: 'Quantity updated',
					icon: 'success',
					showConfirmButton: false,
					timer: 1500,
				})
			} else {
				console.log('Adding new item to cart')
				const itemData = {
					item: this.product,
					quantity: this.quantity,
					variant: this.variant,
					optional: this.store.editingKit && !!this.store.birthKitOptional ? true : undefined,
				}
				if (this.isSearchResult) {
					itemData.queryID = this.queryID
				}
				if (textValues?.length || fileValues?.length) {
					itemData.optionSelections = []
					if (textValues?.length) {
						console.log('Adding text values to item data')
						for (let textValue of textValues) {
							itemData.optionSelections.push({
								option_id: textValue.id,
								option_value: textValue.value,
								option_name: textValue.name,
							})
						}
					}
					if (fileValues?.length) {
						console.log('Adding file values to item data')
						for (let fileValue of fileValues) {
							if (fileValue.fileId) {
								const optionData = {
									option_id: fileValue.modifierId,
									option_value: fileValue.adminUrl,
									option_name: fileValue.modifierName,
									file_url: fileValue.url,
									file_name: fileValue.filename,
								}
								console.log('Option data: ', optionData)
								itemData.optionSelections.push(optionData)
							}
						}
					}
				}
				console.log('Item data: ', itemData)
				const lineItemData = [itemData]

				if (selectedModifierProducts?.length) {
					for (let modProduct of selectedModifierProducts) {
						lineItemData.push({
							item: modProduct,
							quantity: this.quantity,
							variant: modProduct.variants?.[0],
						})
					}
				}
				console.log('Line item data: ', lineItemData)

				if (this.contract?.bcVariantId && !this.store.editingKit) {
					// XCover Warranty Add-To-Cart Logic

					const warrantyData = await this.getWarrantyData()

					this.store.cart?.cartItems?.push?.(...lineItemData, {
						item: warrantyData.product,
						quantity: this.quantity,
						variant: warrantyData.variant,
						optional: {
							optionId: warrantyData.variant.optionValues[0].optionId,
							optionValue: warrantyData.variant.optionValues[0].id,
							coveredProductCode: this.contract?.coveredProductCode,
							productName: this.product.name,
						},
					})

					if (this.showBag) this.store.showBag = true
				} else {
					this.store.cart?.cartItems?.push?.(...lineItemData)
					if (this.showBag) this.store.showBag = true
				}
				// GA4 Add to Cart Event
				if (typeof gtag === 'function') {
					const product = {
						item_id: this.product?.sku || '',
						item_name: this.product?.name,
						quantity: this.quantity,
						price: this.product?.currentPrice,
					}
					const addToCartEvent = gtag('event', 'add_to_cart', {
						send_to: 'AW-387509916',
						ecomm_pagetype: 'cart',
						currency: 'USD',
						items: [product],
						value: product.price,
					})
					console.log('GA4 - Add to cart event: ', addToCartEvent)
				}

				// Algolia Add to Cart Event
				try {
					if (this.searchResult) {
						aa('addedToCartObjectIDsAfterSearch', {
							eventName: 'Product Added To Cart',
							index: 'InHisHands',
							objectIDs: [this.product.id],
							objectData: [
								{
									queryID: this.queryID,
									price: this.variant?.currentPrice || this.product.currentPrice,
									quantity: this.quantity,
								},
							],
							currency: 'USD',
						})
					} else {
						aa('addedToCartObjectIDs', {
							eventName: 'Product Added To Cart',
							index: 'InHisHands',
							objectIDs: [this.product.id],
							objectData: [
								{
									price: this.variant?.currentPrice || this.product.currentPrice,
									quantity: this.quantity,
								},
							],
							currency: 'USD',
							value: this.variant?.currentPrice || this.product.currentPrice,
						})
					}
				} catch (error) {
					console.error('Algolia Add to Cart Event Error', error)
				}
			}

			this.store.showBag = true
		},
		selectOption(option) {
			if (!option) return
			console.log('Existing Options: ', this.selectedOptions)
			console.log('Product: Selecting Option: ', option)
			let options = this.selectedOptions.filter((o) => o.optionId !== option.optionId)
			this.selectedOptions = [...options, option]
		},
		setProduct(p) {
			if (!p || !p.isVisible) {
				this.$router.push('/404')
				return
			}
			for (let po of p?.productOptions || []) {
				for (let o of po.optionValues || []) {
					o.optionId = po.id
				}
				this.selectOption(po.optionValues?.find((o) => o.isDefault))
			}
			p.images = p?.images?.sort((a, b) => a.sortOrder - b.sortOrder)
			this.product = p

			if (this.variant?.id) {
				this.selectedImage = this.variant?.imageUrl || p?.images[0]?.url || '/images/obDefaultProductImage-min.jpg'
			} else {
				this.selectedImage = p?.images[0]?.url || '/images/obDefaultProductImage-min.jpg'
			}

			let existingItem = this.store.cart?.cartItems?.find?.((c) => c.item.id === this.product.id)
			if (existingItem?.quantity) {
				this.quantity = existingItem.quantity
			} else {
				// Default the quantity to one purchase increment (e.g. load at 5 when sold in 5s)
				this.quantity = this.purchaseIncrement
			}

			// console.log('Out of stock? ', this.product?.outOfStock)
			// console.log('Variants out of stock? ', this.variantsOutOfStock)
			if (this.product?.outOfStock || this.variantsOutOfStock) {
				console.log('product out of stock')
			}
		},
		async getWarrantyData() {
			const variant = await Mango.variants({ search: { bcId: Number(this.contract?.bcVariantId) } })
			const product = await Mango.products({ search: { bcId: Number(this.contract?.bcProductId) } })

			return { product: product[0], variant: variant[0] }
		},
		filters() {
			this.filtersApplied = !this.filtersApplied
		},
		setActive(section) {
			this.activeSection = section
		},
		updateImage(image) {
			this.selectedImage = image
		},
		scrollUp() {
			if (this.currentIndex > 0) {
				this.currentIndex -= 5
				this.updateVisibleProducts()
			}
		},
		scrollDown() {
			if (this.currentIndex + 5 < this.products.length) {
				this.currentIndex += 5
				this.updateVisibleProducts()
			}
		},
		updateVisibleProducts() {
			// Update the visibleProducts based on currentIndex
			this.visibleProducts = this.products.slice(this.currentIndex, this.currentIndex + 5)
		},
		async syncRecentlyViewed() {
			let response = await Mango.members.save({ id: this.store.user.id, $push: { recentlyViewed: this.product.id } })
			if (response?.id) {
				if (response.recentlyViewed.length > 10) {
					response.recentlyViewed.shift()
					await Mango.members.save({ id: this.store.user.id, recentlyViewed: response.recentlyViewed })
				}
				this.store.user.recentlyViewed = response.recentlyViewed
			}
		},
		async addRecentlyViewed() {
			if (!this.product?.id) {
				console.log('Error updating recently viewed: product not loaded yet')
				return
			}

			if (!this.store?.user?.id) {
				console.log('Updating recently-viewed for guest user')
				this.store.recentlyViewed.push(this.product)
				if (this.store.recentlyViewed.length > 10) this.store.recentlyViewed.shift()
				localStorage.setItem('recentlyViewed', JSON.stringify(this.store.recentlyViewed))
			} else {
				if (!this.store?.user?.recentlyViewed?.length) {
					this.store.user.recentlyViewed = []
					this.store.user.recentlyViewed.push(this.product.id)
					console.log(`Added product ${this.product.bcId} to recently viewed`)
				} else {
					await this.syncRecentlyViewed()
				}
			}
		},
		shareToEmail() {
			const subject = `${this.product.name} - In His Hands Birth Supply`
			const body = `Check out this product: https://www.inhishands.com${this.product.customUrl.url}`
			const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
			window.location.href = mailtoLink
		},
		shareToPrinter() {
			window.print()
		},
		toggleSocials() {
			this.showSocials = !this.showSocials
		},
		addListItem() {
			console.log('clicked')
			this.showWishlistOptions = !this.showWishlistOptions
		},
		async notifyWhenAvailable() {
			const body = {
				email: this.notifyEmail,
				product: {
					id: String(this.product?.bcId),
					variant_id: String(this.variant?.bcId),
					sku: String(this.product.sku),
				},
			}

			if (!body.product?.variant_id) {
				delete body.product.variant_id
			}

			console.log('Sendlane Request Body: ', body)

			const response = await axios.post(`${this.store.api}/controllers/sendlane/back_in_stock`, body)

			console.log('Response: ', response.data)

			if (response?.data?.message === 'Successfully handled event') {
				this.notifyMessage = 'We will notify you when it becomes available.'
			} else {
				this.notifyMessage = 'There was an error adding your email to the list. Please try again later.'
			}
		},
		showNotifyModal() {
			this.showNotify = true
		},
		addContract(contract) {
			console.log('Product Component: Setting Selected contract')
			this.contract = contract
		},
		removeContract() {
			console.log('Product Component: Removing Selected contract')
			this.contract = null
		},
		async waitForClydeModalToClose() {
			return new Promise((resolve) => {
				const closeHandler = (event) => {
					if (event.data?.type === 'decline' || event.data?.type === 'addProtection') {
						console.log('Clyde modal closed. Resuming cart logic...')
						window.removeEventListener('message', closeHandler)
						resolve() // Resume `addToBag`
					}
				}

				// Add event listener to detect when Clyde closes
				window.addEventListener('message', closeHandler)

				// Open Clyde modal
				if (window?.Clyde?.showModal) {
					console.log('Opening Clyde modal...')
					window.Clyde.showModal()
				} else {
					console.warn('Clyde modal could not be opened.')
					resolve() // Prevent freezing if Clyde doesn't open
				}
			})
		},
		updateZoom(event) {
			const img = this.$refs.zoomImage
			if (!img) return

			// Get bounding box of the image relative to the viewport
			const rect = img.getBoundingClientRect()

			// Calculate mouse position relative to the image
			const xPercent = ((event.clientX - rect.left) / rect.width) * 100
			const yPercent = ((event.clientY - rect.top) / rect.height) * 100

			// Update transform-origin to follow cursor
			this.zoomStyle = {
				transformOrigin: `${xPercent}% ${yPercent}%`,
				objectFit: 'contain',
			}
		},
		resetZoom() {
			// Reset transform-origin when the mouse leaves
			this.zoomStyle = {
				transformOrigin: 'center center',
				objectFit: 'contain',
			}
		},
		getExistingItem() {
			if (this.store.editingKit) return (this.currentCartItem = this.store.editingKit?.products?.find?.((c) => c.product.id === this.product.id))

			if (this.variant?.bcId) return (this.currentCartItem = this.store.cart?.cartItems?.find?.((c) => c?.variant?.bcId === this.variant.bcId))

			return (this.currentCartItem = this.store.cart?.cartItems?.find?.((c) => c.item.id === this.product.id))
		},
		sanitizeProductDescription(description) {
			if (!description) return ''
			// Remove %%GLOBAL_ShopPathSSL%% placeholder
			return description.replace(/%%GLOBAL_ShopPathSSL%%\//g, `${window.location.origin}/`)
		},
		fixLinks() {
			const descriptionContainer = this.$refs.productDescription
			if (descriptionContainer) {
				const links = descriptionContainer.querySelectorAll('a')
				links.forEach((link) => {
					const href = link.getAttribute('href')
					if (href && href.startsWith('/products/')) {
						// Ensure the link is absolute by adding the base URL
						link.setAttribute('href', `${window.location.origin}${href}`)
					}
				})
			}
		},
		validateProductOptionInventory() {
			if (this.product?.outOfStock || this.variantsOutOfStock) {
				// no in-stock variant to set as the selected option: returning
				return
			}

			if (this.product.inventoryTracking === 'product' || this.product.inventoryTracking === 'none') {
				// inventory is not tracked/not tracked by variant
				return
			}

			// check if the selected variant is in stock
			if (this.variant?.inventoryLevel <= 0) {
				// Find the first variant with inventory
				const firstInStockVariant = this.product?.variants?.find((v) => v.inventoryLevel > 0)

				if (firstInStockVariant) {
					// Create a new array to hold the matching option values from productOptions
					const newSelectedOptions = []

					// For each option value in the in-stock variant
					firstInStockVariant.optionValues.forEach((variantOptVal) => {
						// Find the matching option value from the product's productOptions
						this.product.productOptions.forEach((productOption) => {
							const matchingOptionValue = productOption.optionValues.find(
								(optVal) => optVal.id === variantOptVal.id && optVal.optionId === variantOptVal.optionId,
							)

							if (matchingOptionValue) {
								newSelectedOptions.push(matchingOptionValue)
							}
						})
					})

					// Update the selected options with our new array
					this.selectedOptions = newSelectedOptions
				}
			}
		},
		handleQtyChange() {
			if (this.quantity > this.currentStock) {
				this.quantity = this.currentStock
				Swal.fire({
					icon: 'warning',
					title: 'Low Stock',
					text: `Only ${this.currentStock} left in stock!`,
					confirmButtonColor: '#e59789',
				})
			}
		},
		snapQuantity(value) {
			// Round to the nearest valid multiple of the purchase increment, floored at one increment.
			// No-op when the increment is 1.
			const inc = this.purchaseIncrement
			let n = Math.round((Number(value) || inc) / inc) * inc
			if (n < inc) n = inc
			return n
		},
	},
	computed: {
		isPriceHidden() {
			return !!this.product?.isPriceHidden
		},
		priceDisplayLabel() {
			return this.product?.priceHiddenLabel || 'Call for pricing'
		},
		callForPricingPhoneHref() {
			const digits = this.priceDisplayLabel?.replace(/\D/g, '')
			if (!digits || digits.length < 10) return null
			return `tel:+1${digits.slice(-10)}`
		},
		callForPricingEmailHref() {
			const subject = this.product?.name ? `Pricing inquiry: ${this.product.name}` : 'Pricing inquiry'
			return `mailto:help@inhishands.com?subject=${encodeURIComponent(subject)}`
		},
		canPurchaseOnline() {
			return this.product?.availability === 'available'
		},
		purchaseIncrement() {
			// Effective increment: the selected variant's wins, falling back to the product's, then 1.
			const variantInc = Number(this.variant?.purchaseIncrement)
			if (Number.isFinite(variantInc) && variantInc > 0) return variantInc
			const productInc = Number(this.product?.purchaseIncrement)
			if (Number.isFinite(productInc) && productInc > 0) return productInc
			return 1
		},
		existingItem() {
			return this.getExistingItem()
		},
		variant() {
			return this.product?.variants?.find((v) => v.optionValues?.every((o) => this.selectedOptions?.find((so) => so.id == o.id)))
		},
		percentage() {
			if (this.product.wasPrice) {
				const discount = ((this.product.wasPrice - this.product.currentPrice) / this.product.wasPrice) * 100
				return discount.toFixed(0) // Rounds to the nearest whole number
			}
			return null // No discount if salesPrice doesn't exist
		},
		isAtTop() {
			return this.currentIndex <= 0
		},
		isAtBottom() {
			return this.currentIndex + 5 >= this.product?.images?.length
		},
		image() {
			return this.products[this.selectedfeature].image
		},
		sponserPrice() {
			if (this.selectedSponsorship == 'Platinum') return 3500
			if (this.selectedSponsorship == 'Gold') return 2000
			if (this.selectedSponsorship == 'Silver') return 1000
			return 0
		},
		lowStock() {
			if (this.product?.inventoryTracking == 'none') return false

			if (this.product?.inventoryTracking == 'variant') {
				return this.variant?.inventoryLevel <= 5
			} else if (this.product?.inventoryTracking == 'product') {
				return this.product?.inventoryLevel <= 5
			}
		},
		currentStock() {
			if (this.product?.inventoryTracking == 'none') return 500
			if (this.product?.inventoryTracking == 'variant') {
				return this.variant?.inventoryLevel
			} else if (this.product?.inventoryTracking == 'product') {
				return this.product?.inventoryLevel
			}
		},
		stockAvailable() {
			if (this.currentStock > this.quantity) {
				return true
			} else {
				return false
			}
		},
		bulkPricingAvailable() {
			return this.product?.bulkPricingRules?.length > 0
		},
		variantsOutOfStock() {
			return this.product?.variants?.every((v) => v.inventoryLevel <= 0) && this.product.inventoryTracking === 'variant'
		},
		isAddToBagDisabled() {
			if (this.store.editingKit?.id || this.product?.collection == 'birthKits') {
				return false
			}

			// Check if product is out of stock
			if (this.product?.outOfStock) {
				return true
			}

			// Check if all variants are out of stock
			if (this.variantsOutOfStock) {
				return true
			}

			// Check if selected variant is out of stock
			if (this.variant?.inventoryLevel <= 0 && this.product?.inventoryTracking === 'variant') {
				return true
			}

			return false
		},
		cartQty() {
			if (this.variant?.bcId) {
				return this.store.cart?.cartItems?.find?.((c) => c?.variant?.bcId === this.variant.bcId)?.quantity || null
			}
			return this.store.cart?.cartItems?.find?.((c) => c.item.id === this.product.id)?.quantity || null
		},
		currentPrice() {
			// If no variant, return the product price
			if (!this.variant?.id) {
				return this.product?.currentPrice
			}
			// If no variant or quantity is invalid, return the regular price
			if (!this.variant?.currentPrice || !this.quantity || this.quantity <= 0) {
				return this.variant?.currentPrice
			}

			// If no bulk pricing rules available, return the regular price
			if (!this.product?.bulkPricingRules || this.product.bulkPricingRules.length === 0) {
				return this.variant.currentPrice
			}

			// Find the applicable bulk pricing rule based on quantity
			const applicableRule = this.product.bulkPricingRules
				.filter((rule) => this.quantity >= rule.quantityMin && (rule.quantityMax === 0 || this.quantity <= rule.quantityMax))
				.sort((a, b) => b.quantityMin - a.quantityMin)[0] // Get the rule with the highest min quantity that applies

			// If no applicable rule found, return the regular price
			if (!applicableRule) {
				return this.variant.currentPrice
			}

			// Calculate price based on the rule type
			switch (applicableRule.type) {
				case 'price':
					// Price adjustment per product (subtract the amount from the original price)
					return this.variant.currentPrice - applicableRule.amount
				case 'percent':
					// Percentage discount (apply percentage reduction to original price)
					return this.variant.currentPrice * (1 - applicableRule.amount / 100)
				case 'fixed':
					// Fixed price regardless of original price
					return applicableRule.amount
				default:
					return this.variant.currentPrice
			}
		},
		requiredOptionsSelected() {
			let value = true
			let options = []
			if (!this.product?.productOptions?.length) return { value, options }

			if (this.variant?.id) {
				return { value, options }
			}

			this.product.productOptions.forEach((option) => {
				options.push(option.displayName?.toLowerCase())
			})

			return { value: false, options }
		},
		// sanitizedDescription() {
		// 	return this.product.description.replace(/%%GLOBAL_ShopPathSSL%%\//g, '') || ''
		// },
		BlackFridaySaleIsActive() {
			// Check if the product is excluded
			if (this.excludedProducts.includes(this.product?.id)) {
				return false
			}
			const now = new Date()
			// End date: Saturday 11/22/2025 at 11:59 PM CST
			const endDate = new Date('2025-11-22T23:59:59-06:00')
			return now <= endDate
		},
		salePercent() {
			if (!this.BlackFridaySaleIsActive) {
				return 0
			}

			// Check if product is in excluded categories or brands
			const isExcludedCategory = this.product?.categories?.some((cat) => this.excludedCategories.includes(cat.id))
			const isExcludedBrand = this.excludedBrands.includes(this.product?.brandId)

			if (isExcludedCategory || isExcludedBrand) {
				return 10
			}

			// Check if the product is excluded
			if (this.excludedProducts.includes(this.product?.id)) {
				return 0
			}

			const now = new Date()
			// Thursday 11/20/2025 at 11:59 PM CST
			const thursdayEnd = new Date('2025-11-20T23:59:59-06:00')
			// Saturday 11/22/2025 at 11:59 PM CST
			const saturdayEnd = new Date('2025-11-22T23:59:59-06:00')

			if (now <= thursdayEnd) {
				return 15
			} else if (now <= saturdayEnd) {
				return 10
			} else {
				return 0
			}
		},
		salePrice() {
			if (!this.BlackFridaySaleIsActive) return this.currentPrice

			const discount = this.salePercent / 100
			return Math.round(this.currentPrice * (1 - discount) * 100) / 100
		},
	},
}
</script>

<style>
.prose.description a:hover {
	color: #4a4a4a !important;
}

.prose.description a {
	color: #e59789 !important;
}
</style>
